import { Tooltip } from "@mui/material";
import { MentionModel } from "../communication";

type hotkey =
	| "a"
	| "b"
	| "c"
	| "d"
	| "e"
	| "f"
	| "g"
	| "h"
	| "i"
	| "j"
	| "k"
	| "l"
	| "m"
	| "o"
	| "p"
	| "q"
	| "r"
	| "s"
	| "t"
	| "u"
	| "v"
	| "w"
	| "x"
	| "y"
	| "z"
	| "Enter"
	| "Command"
	| "Windows"
	| "Shift"
	| "Escape"
	| "Delete"
	| "Tab"
	| "1"
	| "2"
	| "3"
	| "4"
	| "5"
	| "Click"
	| "/";

export interface ToolTipItemProps {
	keys: hotkey[];
	description: String;
	mentionModel?: MentionModel;
}

interface ToolTipProps {
	items: ToolTipItemProps[];
	mentionModel: MentionModel;
}

export default function ToolTip(props: ToolTipProps) {
	const tooltipItems = props.items.map(
		(item: ToolTipItemProps, index: number) => (
			<ToolTipItem
				key={"tooltip-" + index}
				keys={item.keys}
				description={item.description}
				mentionModel={props.mentionModel}
			/>
		)
	);
	return (
		<Tooltip
			title={
				<div
					className="tooltip-hover"
					style={{
						width: "auto",
						height: "auto",
						backgroundColor: "white",
						display: "flex",
						padding: "20px",
						flexDirection: "column",
					}}>
					{tooltipItems}
				</div>
			}
			arrow
			componentsProps={{
				tooltip: {
					sx: {
						padding: "0",
						boxShadow: "0 5px 5px #0000001F",
						borderRadius: "4px",
						maxWidth: "none",
					},
				},
				arrow: {
					sx: {
						"&::before": {
							backgroundColor: "white",
						},
					},
				},
			}}>
			<div className={"tooltip-icon " + props.mentionModel}>?</div>
		</Tooltip>
	);
}

export function ToolTipItem(props: ToolTipItemProps) {
	let keyItems: JSX.Element[] = [];
	props.keys.forEach((key: hotkey, i, arr) => {
		const char = key.charCodeAt(0);
		if (char >= 97 && char <= 122) {
			keyItems.push(
				<div className={"key-item-" + i + " " + props.mentionModel}>
					{key}
				</div>
			);
		} else {
			switch (key) {
				case "Enter":
					keyItems.push(
						<div
							className={
								"key-item-" + i + " " + props.mentionModel
							}>
							Enter
						</div>
					);
					break;
				case "Click":
					keyItems.push(
						<div className={"key-item " + props.mentionModel}>
							Click
						</div>
					);
					break;
				case "Shift":
					keyItems.push(
						<div className={"key-item " + props.mentionModel}>
							Shift
						</div>
					);
					break;
				case "Delete":
					keyItems.push(
						<div className={"key-item " + props.mentionModel}>
							delete / Backspace
						</div>
					);
					break;
				case "Command":
					keyItems.push(
						<div className={"key-item " + props.mentionModel}>
							<span>{"\u{2318}"}</span> / Ctrl
						</div>
					);
					break;
				case "/":
					keyItems.push(
						<div className={"key-item " + props.mentionModel}>
							/
						</div>
					);
					break;
			}
		}

		if (i !== arr.length - 1) {
			keyItems.push(<div className="delimiter"> + </div>);
		}
	});
	return (
		<div className="tooltip-item ">
			<div className="keys ">{keyItems}</div>
			<div className="description">{props.description}</div>
		</div>
	);
}
